import { Box, Text, Center, Image } from '@chakra-ui/react';
import failedImg from './../assets/status-fail.png';

const CustomFallback = () => {
  return (
    <Center height="100vh">
      <Box
        py={10}
        px={6}
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        textAlign={'center'}
      >
        <Image src={failedImg} boxSize={'150px'} />
        <Text fontSize="2xl">¡Lo sentimos!</Text>
        <Text fontSize="1xl">Hubo un error inesperado. Lo hemos reportado a nuestro equipo.</Text>
      </Box>
    </Center>
  );
};

export default CustomFallback;
